var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons38PxApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 36.989,
    height: 26.433,
    x: 0.506,
    y: 5.506,
    stroke: "#000",
    strokeWidth: 1.011,
    rx: 3.167
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M28.467 15.848l1.57 5.025h.03l1.571-5.025h1.357l-2.339 6.505c-.536 1.492-1.148 1.982-2.445 1.982-.102 0-.429-.012-.518-.035v-1.02c.083.011.286.023.393.023.589 0 .922-.248 1.124-.885l.12-.377-2.256-6.193h1.393zm-18.238-.755h.206c.298.024 1.156.114 1.705.92-.046.034-1.018.59-1.007 1.758.012 1.395 1.236 1.86 1.247 1.872l-.005.016-.027.082c-.07.205-.258.699-.608 1.206-.39.568-.79 1.124-1.43 1.135-.618.012-.824-.363-1.533-.363-.71 0-.938.352-1.522.375-.618.022-1.086-.602-1.475-1.17-.801-1.145-1.407-3.232-.584-4.64.4-.703 1.133-1.145 1.922-1.157.606-.01 1.167.398 1.533.398.3 0 .79-.32 1.379-.41l.2-.022zm13.815.679c1.523 0 2.517.79 2.517 2.016v4.235h-1.232v-1.02h-.03c-.35.666-1.124 1.085-1.964 1.085-1.237 0-2.1-.731-2.1-1.828 0-1.092.84-1.717 2.386-1.81l1.66-.101v-.472c0-.69-.458-1.068-1.273-1.068-.673 0-1.16.343-1.261.867h-1.202c.035-1.103 1.082-1.904 2.499-1.904zm-5.966-2.26c1.666 0 2.827 1.139 2.827 2.796 0 1.663-1.184 2.808-2.868 2.808h-1.845v2.907h-1.333v-8.51h3.22zm7.203 5.721l-1.481.095c-.833.053-1.268.36-1.268.896 0 .52.452.855 1.16.855.905 0 1.59-.572 1.59-1.368v-.478zm-7.554-4.606h-1.535v3.38h1.53c1.16 0 1.82-.62 1.82-1.693s-.66-1.687-1.815-1.687zm-7.286-1.763c.058.546-.16 1.08-.481 1.479-.333.387-.86.694-1.388.648-.07-.523.195-1.08.493-1.421.332-.399.906-.683 1.376-.706z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons38PxApple);
export default __webpack_public_path__ + "static/media/icons-38-px-apple.7ffb9da1db5ce2ca4d696410500216a4.svg";
export { ForwardRef as ReactComponent };